import React from 'react';
import PropTypes from 'prop-types';
import styles from './QuestionKeyWordListDisplay.scss';
import scorableItemNumberingService from '../../services/questionView/ScorableItemNumberingService';
import storeManager from '../../store/StoreManager';
import currentlyShownActions from '../../actions/CurrentlyShownActions';

const QuestionKeyWord = (props) => {
    const { question, response, sectionId, currentScorableItem } = props;

    const placeholderNumber = scorableItemNumberingService.getInteractionNumber(question.contentRevisionId, response.identifier);
    const key = `keyword-${placeholderNumber}`;
    const selected = currentScorableItem === parseInt(placeholderNumber, 10);
    const classNamesList = [styles.keyWordOption];

    if (selected) {
        classNamesList.push(styles.selectedKeyWord);
    }

    const handleClick = () => {
        storeManager.getStore().dispatch(currentlyShownActions.updateCurrentlyShown({
            questionId: question.contentRevisionId,
            route: `/section/${sectionId}/question/${question.contentRevisionId}/scorableItem/RESPONSE-/${placeholderNumber}`,
            routeType: 'question',
            scorableItem: parseInt(placeholderNumber, 10),
            sectionId,
        }));
    };

    return (
        <li id={key}>
            <button className={classNamesList.join(' ')} tabIndex="0" onClick={handleClick} onSelect={handleClick} onKeyUp={handleClick}>
                {placeholderNumber}. {response.keyword}
            </button>
        </li>
    );
};

QuestionKeyWord.propTypes = {
    currentScorableItem: PropTypes.number,
    question: PropTypes.object.isRequired,
    response: PropTypes.object.isRequired,
    sectionId: PropTypes.number.isRequired,
};

export default QuestionKeyWord;
